import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelHistoryLogResponse } from "./dto/history-log.dto";


export class HistoryLogRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getHistoryLogList(
    params: any
  ): Promise<AsyncData<IModelResponse<IModelHistoryLogResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/audit-log-association/audit-log-user`,
      this.configService,
      {
        params
      }
    );
    return dataResult;
  }
}